import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);

// Remove the inline splash screen once React has painted
requestAnimationFrame(() => {
  const win = window as unknown as { __removeSplash?: () => void };
  if (typeof win.__removeSplash === 'function') {
    win.__removeSplash();
  }
});
